// extracted by mini-css-extract-plugin
export default {"title":"FulfillmentTop5_title__op7dm","filterContainer":"FulfillmentTop5_filterContainer__kfO0Q"};